const statisticsSk = {
    "user_statistics": "Štatistiky používateľov",
    "menu_item_clicks": "Kliknutia na položky ponuky",
    "statistics": "Štatistiky",
    "user_traffic": "Návštevnosť používateľov",
    "last_7_days": "Posledných 7 dní",
    "last_30_days": "Posledných 30 dní",
    "menu_item": "Položka ponuky",
    "click_count": "Počet kliknutí",
    "error_fetching_user_statistics": "Chyba pri načítavaní štatistík používateľa.",
    "error_fetching_menu_item_statistics": "Pri načítaní štatistík položiek ponuky sa vyskytla chyba.",
    "statistics_feature_not_available": "Funkcia štatistík je k dispozícii iba v pláne PRO. Pre prístup k tejto funkcii si, prosím, aktualizujte svoje predplatné.",
    "change_subscription_plan": "Zmeniť predplatné",
    "permission_denied": "Povolenie zamietnuté",
    "error_fetching_rating_statistics": "Chyba pri načítaní štatistík hodnotenia.",
    "menu_item_ratings": "Hodnotenia položiek v ponuke",
    "likes": "páči sa mi to",
    "dislikes": "nemá rád",
    "rating_trends_last_7_days": "Trendy hodnotenia (posledných 7 dní)",
    "rating_trends_last_30_days": "Trendy hodnotenia (posledných 30 dní)",
    "kpi_total_visitors": "Celkovo návštevníkov",
    "kpi_avg_per_day": "Priemer / deň",
    "kpi_peak_day": "Špičkový deň",
    "kpi_top_item": "Najkliknutejšia položka",
    "kpi_clicks": "kliknutí",
    "kpi_vs_prev": "vs predchádzajúce obdobie",
    "current_period": "Aktuálne obdobie",
    "previous_period": "Predchádzajúce obdobie",
    "visitors": "návštevníkov",
    "hourly_traffic": "Hodinová návštevnosť",
    "utm_sources": "Zdroje návštevnosti",
    "utm_unknown": "Neznámy",
    "no_data": "Žiadne údaje",
};

export default statisticsSk;
